'use strict'

import Vue from 'vue'
import Router from 'vue-router'

// import { EventBus } from '../helpers/event-bus'
// import VueScrollTo from 'vue-scrollto'

import IpoCredit from '@/components/IpoCredit'
import GeneralTerms from '@/components/policies/GeneralTerms'
import GeneralInfo from '@/components/policies/GeneralInfo'
// import CookiePolicy from '@/components/CookiePolicy'
// const CookiePolicy = () => import('@/components/CookiePolicy')

const _config = require('../_config')

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: _config.BASE_URL,
  // linkActiveClass: 'active', // active class for non-exact links.
  // linkExactActiveClass: 'active', // active class for *exact* links.
  routes: [
    {
      path: '/cookie-policy',
      name: 'CookiePolicy',
      component: () => import('@/components/policies/CookiePolicy')
    },
    {
      path: '/general-terms',
      name: 'GeneralTerms',
      component: GeneralTerms
    },
    {
      path: '/general-info',
      name: 'GeneralInfo',
      component: GeneralInfo
    },
    {
      path: '/*',
      component: IpoCredit
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // if (to.hash) {
    //   // this.$router.push(to)
    //   EventBus.loadLazy(() => {
    //     VueScrollTo.scrollTo(to.hash, 500, {offset: -32})
    //     // return {
    //     //   selector: to.hash
    //     // // , offset: { x: 0, y: 10 }
    //     // }
    //   })

    //   // return {
    //   //   selector: to.hash
    //   //   // , offset: { x: 0, y: 10 }
    //   // }
    // }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js